import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CalendarDays, CircleAlert } from "lucide-react";
import CategorySidebar from "../../components/Sidebar/CategorySidebar";
import "./NewspaperDetail.scss";
import { fetchNew, fetchMenu } from "../../api/newsService";
import DOMPurify from "dompurify";
import { TitleComponent } from "../TitleDocument";
import BreadCrumb from "../../components/BreadCrumb";
import { slugify } from "../../components/Sdata";

const NewspaperDetail = () => {
  const { Id, categoryId } = useParams();
  const [postDetail, setPostDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [slugToIdMap, setSlugToIdMap] = useState({});

  const fetchData = async () => {
    try {
      const categoryRes = await fetchMenu();
      if (categoryRes?.data?.data) {
        const map = {};
        categoryRes.data.data.forEach((item) => {
          const slug = slugify(item.name);
          map[slug] = item.id;
          localStorage.setItem(slug, item.name);
        });
        setSlugToIdMap(map);
      }
    } catch (fetchError) {
      console.error("Error fetching categories:", fetchError);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const getPostDetail = async () => {
      try {
        const numericCategoryId = slugToIdMap[categoryId];
        if (!numericCategoryId) {
          throw new Error(`Category ID not found for slug: ${categoryId}`);
        }
        const res = await fetchNew(Id, numericCategoryId);
        if (res?.data?.data?.lstNews) {
          const detail = res.data.data.lstNews.find((post) => post.id === parseInt(Id, 10));
          setPostDetail(detail);
        } else {
          setError("No post found");
        }
        setLoading(false);
      } catch (fetchError) {
        console.error("Error fetching post detail:", fetchError);
        setError("Failed to load post details.");
        setLoading(false);
      }
    };

    if (slugToIdMap[categoryId] && Id) {
      getPostDetail();
    }
  }, [categoryId, Id, slugToIdMap]);

  const sanitizeHTML = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  const getCategoryTitleWithAccent = (slug) => {
    return localStorage.getItem(slug) || slugify(slug);
  };

  return (
    <section className="news_detail">
      <TitleComponent title={postDetail?.title || "Chi tiết"} />

      <div className="news_detail__shell">
        <div className="news_detail__crumb container">
          <BreadCrumb caseCondition categoryTitle={getCategoryTitleWithAccent(categoryId)} />
        </div>

        <div className="news_detail__container container">
          <div className="news_detail__layout">
            <main className="news_detail__main">
              {loading ? (
                <div className="news_detail__state">
                  <p>Loading...</p>
                </div>
              ) : error ? (
                <div className="news_detail__state news_detail__state--error">
                  <CircleAlert size={18} />
                  <p>{error}</p>
                </div>
              ) : postDetail ? (
                <article className="news_detail__article" key={postDetail.id}>
                  <header className="news_detail__header">
                    <h1>{postDetail.title}</h1>
                    {postDetail.createDate ? (
                      <div className="news_detail__meta">
                        <span className="news_detail__meta-item">
                          <CalendarDays size={15} />
                          {postDetail.createDate}
                        </span>
                      </div>
                    ) : null}
                  </header>

                  <div
                    dangerouslySetInnerHTML={sanitizeHTML(postDetail.content)}
                    className="news_detail__content"
                  />
                </article>
              ) : (
                <div className="news_detail__state">
                  <p>No details found.</p>
                </div>
              )}
            </main>

            <aside className="news_detail__sidebar">
              <CategorySidebar />
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewspaperDetail;
